import { Outlet } from "react-router";

const Gift = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Gift;
